module.exports = __webpack_public_path__ + "static/media/robot.93d043ce.svg";